"use client";
import { enUS as enUSAdapter, arSA as arSAAdapter, th as thAdapter, vi as viVNAdapter, fr as frFRAdapter, tr as trAdapter } from "date-fns/locale";
// date-pickers
import { enUS as enUSDate, viVN as viVNDate, frFR as frFRDate, trTR as trTRDate } from "@mui/x-date-pickers/locales";
// core
import { enUS as enUSCore, arSA as arSACore, thTH as thCore, viVN as viVNCore, frFR as frFRCore, trTR as trTRCode } from "@mui/material/locale";
// data-grid
import { enUS as enUSDataGrid, arSD as arSDDataGrid, viVN as viVNDataGrid, frFR as frFRDataGrid, trTR as trTRDataGrid } from "@mui/x-data-grid/locales";
import merge from 'lodash/merge';

export const allLangs = [
    {
        label: 'English',
        value: 'en',
        systemValue: merge(enUSDate, enUSDataGrid, enUSCore),
        adapterLocale: enUSAdapter,
        icon: 'flagpack:gb-nir',
        numberFormat: {
            code: 'en-US',
            currency: 'USD',
        },
    },
    {
        label: 'French',
        value: 'fr',
        systemValue: merge(frFRDate, frFRDataGrid, frFRCore),
        adapterLocale: frFRAdapter,
        icon: 'flagpack:fr',
        numberFormat: {
            code: 'fr-Fr',
            currency: 'EUR',
        },
    },
    {
        label: 'Vietnamese',
        value: 'vi',
        systemValue: merge(viVNDate, viVNDataGrid, viVNCore),
        adapterLocale: viVNAdapter,
        icon: 'flagpack:vn',
        numberFormat: {
            code: 'vi-VN',
            currency: 'VND',
        },
    },
    // {
    //   label: 'Chinese',
    //   value: 'cn',
    //   systemValue: merge(zhCNDate, zhCNDataGrid, zhCNCore),
    //   adapterLocale: zhCNAdapter,
    //   icon: 'flagpack:cn',
    //   numberFormat: {
    //     code: 'zh-CN',
    //     currency: 'CNY',
    //   },
    // },
    {
        label: 'Arabic',
        value: 'ar',
        systemValue: merge(arSDDataGrid, arSACore),
        adapterLocale: arSAAdapter,
        icon: 'flagpack:sa',
        numberFormat: {
            code: 'ar',
            currency: 'AED',
        },
    },
];
export const defaultLang = allLangs[0]; // English